// ============================================
// LAYOUT - App Layout (Dashboard Principal)
// ============================================

import { Outlet } from 'react-router-dom';
import { Sidebar } from '../components/Sidebar';
import { Navbar } from '../components/Navbar';
import { ToastContainer } from '@almacenes/ui';
import { useUIStore } from '@almacenes/core';

export const AppLayout = () => {
  const sidebarOpen = useUIStore((state) => state.sidebarOpen);
  const toastQueue = useUIStore((state) => state.toastQueue);
  const removeToast = useUIStore((state) => state.removeToast);

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Navbar */}
        <Navbar />

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto relative">
          <Outlet />
        </main>
      </div>

      {/* Overlay para móvil */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-20 bg-black bg-opacity-50 lg:hidden"
          onClick={() => useUIStore.getState().toggleSidebar()}
        />
      )}

      {/* Toast Container */}
      <ToastContainer toasts={toastQueue} onClose={removeToast} />
    </div>
  );
};
